import { render } from "./documents_editor_redact.vue?vue&type=template&id=a175cc80"
import script from "./documents_editor_redact.vue?vue&type=script&lang=js"
export * from "./documents_editor_redact.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__